import { InfoIcon } from "@cpj-ai/panel-npm-package";
import { Card, CardBody } from "@heroui/react";

interface IAiJobPositionCreatorLayoutProps {
  children: React.ReactNode;
  description: string;
}

const AiJobPositionCreatorLayout = ({ children, description }: IAiJobPositionCreatorLayoutProps) => {
  return (
    <div className="space-y-6 w-full">
      <Card className="mb-10 bg-blue-50">
        <CardBody>
          <div className="flex items-center gap-2 mb-2">
            <InfoIcon className="stroke-blue-600 w-6 h-6" />
            <p className="font-medium text-blue-600">How it works</p>
          </div>
          <p className="text-sm text-gray-600">{description}</p>
        </CardBody>
      </Card>
      {children}
    </div>
  );
};

export default AiJobPositionCreatorLayout;
